'use client';
import { useGetBoard } from '@/entites/notice/model/use-board';
// import { boardService } from '@/shared/api/server/board';
import PcInformation from '@/widgets/main/information/ui/PcInformation';
import PcMainBanner from '@/widgets/main/main-banner/ui/PcMainBanner';
import PcBoardNotice from '@/widgets/main/notice/ui/PcBoardNotice';
import PcQuickService from '@/widgets/main/quick-service/ui/PcQuickService';
import PcTourInformation from '@/widgets/main/tour-information/ui/PcTourInformation';

const PcHome = () => {
  // SSR 오류(ECONNRESET) 인해 CSR로 일단 변경
  // const notices = await boardService.find({
  //   boardType: VBC001,
  //   pageNo: 1,
  //   itemCount: 5,
  //   year: 0,
  // });
  const query = {
    boardType: 'VBC001',
    pageNo: 1,
    itemCount: 5,
    year: 0,
  };
  const { data } = useGetBoard(query, ['notice', query.pageNo.toString(), query.year.toString()]);

  return (
    <>
      <PcMainBanner />
      <PcQuickService />
      {/* <PcRectangularNotice initialNotices={notices} /> */}
      <PcBoardNotice initialNotices={data?.items ?? []} />
      <PcInformation />
      <PcTourInformation />
    </>
  );
};

export default PcHome;
